export default {
    header: {
        logOut: 'Log out',
        login: 'Authorization',

        taskList: 'Task List',
        taskView: 'Viewing a task',

        orderList: 'Order List',
        orderTest: 'Test order | Working with test orders',
        orderView: 'Viewing an order',

        refundIndex: 'Refund',
        refundList: 'List of refund operations',
        actualReturn: 'Return from courier service',
        refundCheck: 'Making a refund',
        refundCreate: 'Making a refund',
        returnFromKuperVitrina: 'Return from Kuper Vitrina',
        exchangeIndex: 'Exchange',
        exchangeCheck: 'Making an exchange',
        exchangeCreate: 'Making an exchange',
        exchangeList: 'List of exchange operations',

        admin: 'Administration',

        issue: 'The list of tasks for delivery to delivery',
        actualIssueDeliveryView: 'Delivery to delivery',
        noActualIssueDelivery: 'Irrelevant tasks for delivery to delivery',

        settingMain: 'Settings',
        settingOrderChangeStatus: 'Changing the order status',
        settingExternalService: 'Enabling services',
        settingPermission: 'Accesses',
        settingRoleIndex: 'Configuring Roles',
        settingRoleMain: 'Configuring Roles',
        settingRoleOrderStatus: 'Configuring Roles: Order Statuses',
        settingMailingList: 'Administration of mailing list recipients',
        settingEventList: 'Event Management',
        settingSap: 'Sending requests to SAP',
        settingSapBatch: 'Массовая отправка проводок в SAP',
        settingSapBatchTaskDetail: 'Задание на массовую отправку проводок № {id}',
        settingAcceptanceActList: 'APP History | History of acceptance and transfer certificates',
        settingAtol: 'Atol | Sending receipts to Atol',
        settingSetKit: 'SetKit | SetKit',
        settingCheck: 'Check | Check',
        settingDistribution: 'Order distribution | Order distribution',
        settingUIPriority: 'Settings UI',
        settingReports: 'Reports',
        settingReferenceIndex: 'CRM Section Compliance Page',
        settingAlertsIndex: 'Alerts',

        customerList: 'Customer list',
        customerView: "Viewing the buyer's page | Customer",

        feedbackList: 'Feedback',
        language: 'Language',
        tracknumSearchIndex: 'Search for orders',
        partners: 'Partners',
        returnFromShipping: 'Return from shipping',
        refundYandex: 'Refunds from Yandex.Eda',
    },

    menu: {
        collapse: 'Collapse the menu',
        tasks: 'Tasks',
        orders: 'Orders',
        refund: 'Exchange/Refund',
        admin: 'Administration',
        issue: 'Delivery to the courier for delivery',
        settings: 'Settings',
        customer: 'Customers',
        feedback: 'Feedback',
        refundMobile: 'Refund',
        returnFromKuperVitrinaMobile: 'Refund',
    },

    status: {
        ready: 'ready',
        process: 'process',
        waiting: 'waiting',
        fail: 'fail',
    },

    check: {
        placeholder: 'Order number',
        title: 'Order №',
        notFound: 'Order not found!',
        button: 'Show',
    },

    checkVersion: {
        title: 'New version of the program!',
        text: 'You need to refresh the page',
        button: 'Update',
    },

    error: 'Page not found',
    // eslint-disable-next-line max-len
    errorIsNotAvailableOnMobile: 'The order has moved to the correct status. You can view the order from your computer. Process the next order.',

    exception: {
        title: 'Error',
        warning: 'Warning',
        button: 'Close',
        ok: 'Хорошо',
    },

    'return': 'Return',

    buttons: {
        actual: 'Actual',
        noActual: 'Irrelevant',
        all: 'All',
        hand: 'Hand',
        auto: 'Automatic',
        confirm: 'Confirm',
        backMake: 'Back to the design',
        clearFilter: 'Clear filter',
        yes: 'Yes',
        no: 'No',
        save: 'Save',
        cancel: 'Cancel',
        cancel2: 'Cancel',
        assembly: 'Assembly',
        call: 'Call',
        assemblyReminder: 'Assembly reminder',
        close: 'Закрыть',
    },

    modal: {
        title: 'Attention!',
        updatePage: 'Refresh page',
        updatePageMessage: 'Something went wrong. Try refreshing the page.',
    },

    helpPage: {
        tooltip: 'Go to help page',
    },

    support: {
        tooltip: 'Create a support ticket',
    },

    page: {
        'default': 'Default',
    },

    warnings: {
        uncompletedOrders: {
            strong: 'ATTENTION! YOU HAVE UNFINISHED ORDERS!',
            // eslint-disable-next-line max-len
            text: 'Go to the “Orders” section and complete them! If you do NOT complete overdue tasks, there may be discrepancies in store balances.',
        },
    },
    external: {
        // eslint-disable-next-line max-len
        text: 'Attention, changing the state of services may negatively affect the operation of the system. Are you sure you want to save your changes?',
        ok: 'Confirm',
        cancel: 'Cancel',
        done: 'Done',
    },

    accessDenied: {
        title: 'Доступ запрещен',
        description: 'Введите другие учетные данные',
        button: 'Попробовать снова',
        crm: 'CRM',
    },

    countryName: {
        RU: 'Russia',
        BY: 'Belarus',
        KZ: 'Kazakhstan',
        LV: 'Latvia',
        AE: 'UAE',
    },

    modalReload: {
        title: 'Error',
        message: 'The page has been updated. The order data has changed',
        ok: 'OK',
    },
};